/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { TermDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Term<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description 약관 정보
   *
   * @tags term
   * @name GetTerm
   * @summary 약관 정보
   * @request GET:/v2/terms/{termId}
   * @secure
   */
  getTerm = (termId: number, params: RequestParams = {}) =>
    this.http.request<TermDto, any>({
      path: `/v2/terms/${termId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description 약관 수정
   *
   * @tags term
   * @name UpdateTerm
   * @summary 약관 수정
   * @request PUT:/v2/terms/{termId}
   * @secure
   */
  updateTerm = (termId: number, data: TermDto, params: RequestParams = {}) =>
    this.http.request<TermDto, any>({
      path: `/v2/terms/${termId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description 약관 삭제
   *
   * @tags term
   * @name DeleteTerm
   * @summary 약관 삭제
   * @request DELETE:/v2/terms/{termId}
   * @secure
   */
  deleteTerm = (termId: number, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/v2/terms/${termId}`,
      method: 'DELETE',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description 약관 목록
   *
   * @tags term
   * @name GetTerms
   * @summary 약관 목록
   * @request GET:/v2/terms
   * @secure
   */
  getTerms = (params: RequestParams = {}) =>
    this.http.request<TermDto[], any>({
      path: `/v2/terms`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description 약관 생성
   *
   * @tags term
   * @name CreateTerm
   * @summary 약관 생성
   * @request POST:/v2/terms
   * @secure
   */
  createTerm = (data: TermDto, params: RequestParams = {}) =>
    this.http.request<TermDto, any>({
      path: `/v2/terms`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
